import React from "react";
import { toString, isFinite } from "lodash";
import formatSequencial from "@tvg/formatter/numeric";
import BeatenDistance from "../BeatenDistance";
import Position from "./styled-components";

interface BeatenDistanceValues {
  accBeatenDistance: string;
  accBeatenDistanceStatus: string;
}

interface WinnerDistanceValues {
  winningDistance: string;
  winningDistanceStatus: string;
}

interface Props {
  finishPosition?: number;
  finishStatus?: string;
  numRunners: number;
  accBeatenDistance: BeatenDistanceValues;
  winningDistance: WinnerDistanceValues;
}

const getNonNumericPosition = (
  finishPosition: number | undefined,
  finishStatus: string | undefined,
  numRunners: number
) => {
  if (finishStatus && finishPosition === 0) {
    return <Position>{`${finishStatus.toUpperCase()}/${numRunners}`}</Position>;
  }
  if (isFinite(finishPosition)) {
    if (finishPosition && finishPosition <= 0) {
      return <Position nonNumeric>SCR</Position>;
    }
  }
  return <Position nonNumeric>{`-/${numRunners}`}</Position>;
};

const getPosition = (
  finishPosition: number,
  numRunners: number,
  accBeatenDistance: BeatenDistanceValues,
  winningDistance: WinnerDistanceValues
) => {
  const isWinner: boolean = finishPosition === 1;
  return (
    isFinite(finishPosition) && (
      <Position isWinner={isWinner}>
        {`${finishPosition}${formatSequencial(finishPosition).replace(
          toString(finishPosition),
          ""
        )}/${numRunners}`}
        <BeatenDistance
          isWinner={isWinner}
          beatenDistance={
            isWinner
              ? winningDistance.winningDistance
              : accBeatenDistance.accBeatenDistance
          }
          beatenDistanceStatus={
            isWinner
              ? winningDistance.winningDistanceStatus
              : accBeatenDistance.accBeatenDistanceStatus
          }
        />
      </Position>
    )
  );
};

const PositionInfo = ({
  finishPosition,
  finishStatus,
  numRunners,
  accBeatenDistance,
  winningDistance
}: Props) => (
  <>
    {typeof finishPosition === "number" &&
    !!finishPosition &&
    finishPosition > 0 &&
    finishPosition <= +numRunners
      ? getPosition(
          finishPosition,
          numRunners,
          accBeatenDistance,
          winningDistance
        )
      : getNonNumericPosition(finishPosition, finishStatus, numRunners)}
  </>
);

PositionInfo.defaultProps = {
  finishPosition: null,
  numRunners: 10,
  accBeatenDistance: {
    accBeatenDistance: "",
    accBeatenDistanceStatus: ""
  },
  winningDistance: {
    winningDistance: "",
    winningDistanceStatus: ""
  }
};

export default PositionInfo;
